import { createAction, props } from '@ngrx/store';
import { Prop } from '../../models/Prop';

export enum NotificationActions {
  ShowNotificationSuccess = '[Notification] Show Notification Success',
  ShowNotificationInfo = '[Notification] Show Notification Info',
  ShowNotificationConfirm = '[Notification] Show Notification Confirm',
}

export const showNotificationSuccess = createAction(
  NotificationActions.ShowNotificationSuccess,
  props<Prop<string>>()
);

export const showNotificationInfo = createAction(
  NotificationActions.ShowNotificationInfo,
  props<Prop<string>>()
);

export const showNotificationConfirm = createAction(
  NotificationActions.ShowNotificationConfirm,
  props<Prop<string>>()
);
